import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { HeaderService } from '../../services/header.service';
import { AuthService } from '../../services/auth.services';

export interface Profile {
  firstName: string;
  name: string;
  imageProfile?: any;
}

@Component({
  selector: 'app-profile',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  private authService = inject(AuthService);
  private headerService = inject(HeaderService);
  private cdr = inject(ChangeDetectorRef);

  showProfileMenu: boolean = false;
  profile: Profile | null = null;
  defaultImageProfile: string = 'imgs/defaultAvatar.webp';

  ngOnInit(): void {
    this.headerService.profileSubject.subscribe({
      next: (profile: Profile | null) => {
        if (!profile) return;

        profile.imageProfile = this.defaultImageProfile;
        this.profile = profile;
        this.cdr.detectChanges();
      },
    });

    const userInfo = this.authService.getUserInfo();

    if (userInfo) {
      this.headerService.updateProfile({
        firstName: userInfo.nome.split(' ')[0],
        name: userInfo.nome,
        imageProfile: userInfo.picture,
      });
    } else if (this.authService.isAuthenticated()) {
      // Se está autenticado mas não tem userInfo, tenta recarregar
      this.authService.userInfo().subscribe({
        next: (userInfo) => {
          sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.headerService.updateProfile({
            firstName: userInfo.nome.split(' ')[0],
            name: userInfo.nome,
            imageProfile: userInfo.picture,
          });
        },
        error: (error) => {
          console.error('Erro ao recarregar userInfo:', error);
          this.authService.logout();
        }
      });
    } else {
      this.headerService.updateProfile(null);
    }
  }

  logout(): void {
    this.authService.logout();
  }
}
